export function getCeilingHpGain(maxHp, currentHp, gain=0) {
  const total = currentHp + gain;
  if (total > maxHp) {
    return gain - (total - maxHp);
  }
  return gain;
}